import { atom } from "recoil";

const inGameLoopState = atom<boolean>({
  key: "inGameLoopState",
  default: false,
});

export default inGameLoopState;
